import * as React from 'react';
import { IPaginatedLandingContent } from '../models/paginated-landing-content'
import { LandingPageContent } from './landing-page-content';

interface IProps {
    items: IPaginatedLandingContent[];
    currentPage: number;
    pageSize: number;
    searchText: string;
}

export class ContentList extends React.Component<IProps, any> {

    render() {
        const { items, currentPage, pageSize, searchText } = this.props;

        let currentMinimum = (currentPage - 1) * pageSize;
        let currentMaximum = currentPage * pageSize;

        let paginatedItems = items.slice(currentMinimum, currentMaximum) as IPaginatedLandingContent[];

        return (
            <React.Fragment>
                {this.renderItems(paginatedItems)}
            </React.Fragment>
        );
    }

    renderItems = (paginatedItems: IPaginatedLandingContent[]) => {
        return (
            <div className="paginated-template-inner">
                {paginatedItems.map((item, i) => <LandingPageContent content={item} key={i} />)}
            </div>
        )
    }
}





